module.exports = __webpack_public_path__ + "img/logo_poolinq_white.09ceffd8.svg";